angular.
module("dx.webapp.login").
controller("DxLoginFormController", function LoginFormController(
	$location,
	$window,
	$rootScope,

	Auth,
	DX_URLS,

	dxDialog
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;

	self.state = {
		loading: false,
	};

	self.credentials = {
		email: null,
		password: null,
	};

	var queryStringEmail = $location.search().email;
	if (queryStringEmail) {
		self.credentials.email = queryStringEmail;
	}

	self.emailChanged = function emailChanged() {
		if (self.credentials.email && (self.credentials.email.indexOf("@edu.stockholm.se") !== -1 || self.credentials.email.indexOf("@elevmail.stockholm.se") !== -1)) {
			var scope = $rootScope.$new();
			scope.$window = $window;
			scope.close = function close() {
				dxDialog.closeMostRecent();
			};
			dxDialog.show({
				templateUrl: "/partials/popups/login-with-sthlm-stad.html",
				$scope: scope,
			});
		}
	};

	self.submitForm = function submitForm() {
		if (self.state.loading) {
			return;
		}

		self.state.loading = true;
		Auth.login(self.credentials).then(null, submitFailed);
	};

	self.forgotPasswordClicked = function forgotPasswordClicked() {
		dxDialog.closeMostRecent();
		$location.url(DX_URLS.get("forgotPassword"));
	};

	// Only need to reset loading if failed, because if success the directive should be unloaded
	// and the submit button would just flash to 'enabled' quickly before it disappears.
	function submitFailed() {
		self.state.loading = false;
	}
});
